'use client'

import useWindowSize from '@/lib/useWindowSize'
import { useHamburgerContext } from '@/components/common/Hamburger'
import { useDirectionContext } from '@/components/common/DirectionSelect'
import { useEffect, useState } from 'react'

const StatusBar = () => {
  const { width, height } = useWindowSize()
  const { isOpen } = useHamburgerContext()
  const { direction } = useDirectionContext()
  const [mounted, setMounted] = useState(false)

  const mocking = process.env.NEXT_PUBLIC_API_MOCKING ?? 'disabled'

  useEffect(() => {
    setMounted(true)
    return () => setMounted(false)
  }, [])

  const Breakpoint = () => {
    return (
      <div className="">
        <div className="hidden max-3xs:block bg-white dark:bg-black">(4xs)</div>
        <div className="hidden 3xs:max-2xs:block bg-white dark:bg-black">
          3xs
        </div>
        <div className="hidden 2xs:max-xs:block bg-white dark:bg-black">
          2xs
        </div>
        <div className="hidden xs:max-sm:block bg-white dark:bg-black">xs</div>
        <div className="hidden sm:max-md:block bg-white dark:bg-black">sm</div>
        <div className="hidden md:max-lg:block bg-white dark:bg-black">md</div>
        <div className="hidden lg:max-xl:block bg-white dark:bg-black">lg</div>
        <div className="hidden xl:max-2xl:block bg-white dark:bg-black">xl</div>
        <div className="hidden 2xl:max-3xl:block bg-white dark:bg-black">
          2xl
        </div>
        <div className="hidden 3xl:max-4xl:block bg-white dark:bg-black">
          3xl
        </div>
        <div className="hidden 4xl:block bg-white dark:bg-black">4xl</div>
      </div>
    )
  }

  const Empty = () => {
    return (
      <div className="text-xs flex bg-teal-400 overflow-x-auto justify-between"></div>
    )
  }

  const Status = () => {
    {
      /* Safari 3x zoom-out ; 7x zoom-in - Chrome 7x zoom-out ; 9x zoom-in */
    }
    {
      /* @@BUG: Maximum zoom-out causes rounded edge of browser Chrome to overlap with text on status bar */
    }
    {
      /* MacBook Pro M2 2022: 2880x1640 (usable Safari browser space, zoom-out: maximum) */
    }
    {
      /* MacBook Pro M2 2022: 2880x1630 (usable Chrome browser space, zoom-out: 50%) */
    }
    return (
      <div className="text-xs truncate px-1 2xs:px-1 xs:px-2 sm:px-3 md:px-4 lg:px-5 xl:px-6 2xl:px-7 flex 3xs:bg-blue-200 2xs:bg-gray-200 xs:bg-blue-800 sm:bg-amber-800 md:bg-yellow-400 lg:bg-purple-400 xl:bg-gray-400 2xl:bg-teal-400 3xl:bg-purple-400 4xl:bg-pink-400 overflow-x-auto justify-between">
        <div className="bg-white dark:bg-black">STATUS</div>
        <div className="bg-white dark:bg-black">
          base_url={process.env.NEXT_PUBLIC_BASE_URL}
        </div>
        <div className="bg-white dark:bg-black">mocking={mocking}</div>
        <Breakpoint />
        <div className="bg-white dark:bg-black">
          [{width},{height}]
        </div>
        <div className="bg-white dark:bg-black">[direction={direction}]</div>
        <div className="bg-white dark:bg-black">
          [isOpen={isOpen ? 'true' : 'false'}]
        </div>
        <div className="bg-white dark:bg-black">DASH</div>
      </div>
    )
  }

  let Contents = Status
  if (!mounted) {
    Contents = Empty
  }

  return (
    // NOTE: StatusBar should appear below Tooltip: z-40.
    <output
      aria-label="status-bar"
      className="fixed inset-x-0 bottom-0 bg-yellow-400 z-40"
    >
      <Contents />
    </output>
  )
}

export default StatusBar
